import { Suspense, lazy } from 'react'
import Navbar from '@/components/Navbar'
import HeroUploader from '@/components/HeroUploader'
import ToolGrid from '@/components/ToolGrid'
import TechFeatures from '@/components/TechFeatures'
import Footer from '@/components/Footer'
import SEOHead from '@/components/SEOHead'

// Lazy-load ROI calculator (Recharts chart — lazy for Core Web Vitals)
const ROICalculator = lazy(() => import('@/components/ROICalculator'))
// Lazy-load PDF to PNG converter (pdfjs-dist + JSZip are heavy — only load on demand)
const PdfToPngConverter = lazy(() => import('@/components/PdfToPngConverter'))
// Lazy-load Markdown to PDF editor (marked + DOMPurify + jsPDF + html2canvas — only load on demand)
const MdToPdfEditor = lazy(() => import('@/components/MdToPdfEditor'))
// Lazy-load EPUB to PDF converter (jszip + dompurify + jspdf + html2canvas — only load on demand)
const EpubToPdfConverter = lazy(() => import('@/components/EpubToPdfConverter'))

export default function Home() {
  return (
    <>
      <SEOHead />
      <div className="min-h-screen bg-[#f8f9fb] flex flex-col">
        <Navbar />
        <main id="main-content" tabIndex={-1} className="flex-1">
          <HeroUploader />
          <TechFeatures />
          <ToolGrid />
          <Suspense
            fallback={
              <div className="py-24 flex items-center justify-center" aria-label="Loading PDF to PNG tool">
                <div className="w-8 h-8 rounded-full border-2 border-indigo-200 border-t-indigo-600 animate-spin" />
              </div>
            }
          >
            <PdfToPngConverter />
          </Suspense>
          <Suspense
            fallback={
              <div className="py-24 flex items-center justify-center" aria-label="Loading Markdown to PDF tool">
                <div className="w-8 h-8 rounded-full border-2 border-indigo-200 border-t-indigo-600 animate-spin" />
              </div>
            }
          >
            <MdToPdfEditor />
          </Suspense>
          <Suspense
            fallback={
              <div className="py-24 flex items-center justify-center" aria-label="Loading EPUB to PDF tool">
                <div className="w-8 h-8 rounded-full border-2 border-indigo-200 border-t-indigo-600 animate-spin" />
              </div>
            }
          >
            <EpubToPdfConverter />
          </Suspense>
          <Suspense
            fallback={
              <div className="py-24 flex items-center justify-center" aria-label="Loading ROI calculator">
                <div className="w-8 h-8 rounded-full border-2 border-indigo-200 border-t-indigo-600 animate-spin" />
              </div>
            }
          >
            <ROICalculator />
          </Suspense>
        </main>
        <Footer />
      </div>
    </>
  )
}
